/** Status policy only; callers retain permission and workspace visibility checks. */
export function canPlanSupplierOrderTransport(
  status: string | undefined,
  { inDeliveryWorkspace }: { inDeliveryWorkspace: boolean },
): boolean {
  // The delivery workspace can plan the remainder after a partial receipt;
  // the stage aside stops offering planning once receipt has started.
  return status !== 'RECEIVED' && status !== 'INVOICED'
    && (inDeliveryWorkspace || status !== 'PARTIALLY_RECEIVED');
}
